import Navbar from './components/Navbar';
import BreakingTicker from './components/BreakingTicker';
import HeroLead from './components/HeroLead';
import TodayFeed from './components/TodayFeed';
import ExplosiveSection from './components/ExplosiveSection';
import Timeline from './components/Timeline';
import HotRank from './components/HotRank';
import TrustFaq from './components/TrustFaq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#faf9f7] pb-0">
      <Navbar />
      <BreakingTicker />
      <main>
        <HeroLead />
        <TodayFeed />
        <ExplosiveSection />
        <Timeline />
        <HotRank />
        <TrustFaq />
      </main>
      <Footer />
    </div>
  );
}